import paths from "../../api/paths.api";
import {
  ALL_ESTIMATION_MODULE_NAMES,
  APP_MODULES,
} from "../../constants/appModules";

export const userNavItems = [
  {
    label: "Estimation",
    type: "link",
    link: paths.myEstimation,
    modulesAny: ALL_ESTIMATION_MODULE_NAMES,
  },
  {
    label: "EPCM",
    type: "link",
    link: paths.myProjects,
    module: APP_MODULES.EPCM,
  },
  {
    label: "AIMS",
    type: "link",
    link: paths.ams,
    module: APP_MODULES.AIMS,
  },
  {
    label: "Material",
    type: "link",
    link: paths.myMaterialRecords,
    module: APP_MODULES.MATERIAL,
  },
  {
    label: "Software",
    type: "link",
    link: paths.softwares,
    module: APP_MODULES.SOFTWARE,
  },
  {
    label: "Client data",
    type: "link",
    link: paths.clientVendors,
  },
  {
    label: "Licences",
    type: "link",
    link: paths.licenceManagement,
    adminOnly: true,
    module: APP_MODULES.LICENCE_ADMIN,
  },
];
